import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import payoneer from './../../img/icons/payoneer.png';
import pp from './../../img/icons/pp.png';
import skrill from './../../img/icons/skrill.png';
import Icon from './../Icon';
import PaymentsTypeDropdown from './PaymentsTypeDropdown';

import { userSetFieldFetch } from './../../store/user/actions';

import validation from './../../utils/validation';
import classNames from './../../utils/classNames';
import formatTime from './../../utils/formatTime';

const methods = {
    PAYPAL: 'PAYPAL',
    SKRILL: 'SKRILL',
    Payoneer: 'Payoneer'
};

const getMethodName = method => {
    switch (method) {
        case methods.PAYPAL:
            return 'PayPal';
        case methods.SKRILL:
            return 'Skrill';
        case methods.Payoneer:
            return 'Payoneer';
        default:
            return null;
    }
};

class PaymentInfoForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            payPalValue: '',
            skrillValue: '',
            payoneerValue: ''
        };

        this.onPayoneerSubmit = this.onPayoneerSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.onSavePayMethod = this.onSavePayMethod.bind(this);
    }

    componentDidMount() {
        const { payMethodList } = this.props;
        this.setState({
            payPalValue: payMethodList.PAYPAL.value,
            skrillValue: payMethodList.SKRILL.value,
            payoneerValue: payMethodList.Payoneer.value,
        });
    }

    onInputChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    onSavePayMethod(value) {
        const { savePayMethodDropdown } = this.props;
        savePayMethodDropdown(value);
    }

    onPayoneerSubmit(event) {
        event.preventDefault();
        const { payMethodList, savePayMethodValue } = this.props;
        const { payoneerValue } = this.state;
        const methodItem = payMethodList.Payoneer;
        const isModified = payoneerValue !== methodItem.value;

        if (!isModified || !this.isPayoneerValid()) {
            return;
        }
        savePayMethodValue(methods.Payoneer, payoneerValue);
    }

    isPayoneerValid() {
        const { payoneerValue } = this.state;
        return /^Nerdy[0-9]{1,}$/.test(payoneerValue);
    }

    renderPayPalForm() {
        const { payMethodList, savePayMethodValue, changeLocked } = this.props;
        const { payPalValue } = this.state;
        const methodItem = payMethodList.PAYPAL;
        const isModified = payPalValue !== methodItem.value;
        const isValid = !!payPalValue && validation.isEmail(payPalValue);
        return (
            <form onSubmit={event => { event.preventDefault(); isModified && isValid && savePayMethodValue(methods.PAYPAL, payPalValue) }}>
                <div className="row vertical">
                    <div className="col-3 no-padding">
                        <input
                            type="text"
                            name="payPalValue"
                            className="input-text"
                            placeholder="Enter your Paypal id"
                            value={payPalValue}
                            onChange={this.onInputChange}
                            disabled={changeLocked}
                        />
                    </div>
                    <div className="col-1">
                        {isModified &&
                            <button className="btn btn-bright-success" type="submit" disabled={!isValid}>Verify</button>
                        }
                        {!isModified && methodItem.verified &&
                            <span className="status-box"><Icon className="svg-icon success" iconName="check-fill" />Verified</span>
                        }
                    </div>
                </div>
            </form>
        )
    }

    renderSkrillStatus() {
        const { payMethodList, isSkrillReqsMet, skrillLink } = this.props;
        const methodItem = payMethodList.SKRILL;
        if (!isSkrillReqsMet) {
            return (
                <div className="status-box tooltip">
                    <Icon className="svg-icon" iconName="error" /><a className="tooltip-trigger">Error</a>
                    <div className="tooltip-content">
                        <b>Possible reasosns:</b>
                        <ul>
                            <li>• Select country</li>
                            <li>• Submit passport details</li>
                            <li>• Submit residency details</li>
                            <li>• Accept Skrill terms and conditions</li>
                        </ul>
                    </div>
                </div>
            );
        }
        if (methodItem.verified) {
            return (<span className="status-box"><Icon className="svg-icon success" iconName="check-fill" />Verified</span>)
        }
        if (skrillLink) {
            return (<span className="status-box"><a href={skrillLink} target="_blank" rel="noopener noreferrer">Accept terms</a></span>)
        }
        if (methodItem.pending) {
            return (<span className="status-box"><Icon className="svg-icon" iconName="watch" />In progress</span>);
        }
        return null;
    }

    renderSkrillForm() {
        const { payMethodList, savePayMethodValue, changeLocked } = this.props;
        const { skrillValue } = this.state;
        const methodItem = payMethodList.SKRILL;
        const isModified = skrillValue !== methodItem.value;
        const isValid = !!skrillValue && validation.isEmail(skrillValue);
        return (
            <form onSubmit={event => { event.preventDefault(); isModified && isValid && savePayMethodValue(methods.SKRILL, skrillValue) }}>
                <div className="row vertical">
                    <div className="col-3 no-padding">
                        <input
                            type="text"
                            name="skrillValue"
                            className="input-text"
                            placeholder="Enter your Skrill id"
                            value={skrillValue}
                            onChange={this.onInputChange}
                            disabled={changeLocked}
                        />
                    </div>
                    <div className="col-1">
                        {isModified &&
                            <button className="btn btn-bright-success" type="submit" disabled={!isValid}>Verify</button>
                        }
                        {!isModified && this.renderSkrillStatus()}
                    </div>
                </div>
            </form>
        );
    }

    renderPayoneerStatus() {
        const { payMethodList } = this.props;
        const { payoneerValue } = this.state;
        const methodItem = payMethodList.Payoneer;
        const showMessageBrideford = /^Brideford.*$/.test(payoneerValue);
        const isModified = payoneerValue !== methodItem.value;
        const isValid = this.isPayoneerValid();

        if (showMessageBrideford) {
            return (
                <div className="status-box tooltip">
                    <Icon className="svg-icon" iconName="error" /><a className="tooltip-trigger hover">Error</a>
                    <div className="tooltip-content">
                        Oops, this ID is not valid any more.<br />
                        Simply follow the payment link below to set up a new one, it won&apos;t take more then 3 minutes of your time.
              </div>
                </div>
            );
        }
        if (isModified) {
            return (<button className="btn btn-bright-success" type="submit" disabled={!isValid}>Verify</button>);
        }
        if (methodItem.verified) {
            return (<span className="status-box"><Icon className="svg-icon success" iconName="check-fill" />Verified</span>);
        }
        if (methodItem.pending) {
            return (<span className="status-box"><Icon className="svg-icon" iconName="watch" />In progress</span>);
        }
        return null;
    }

    renderPayoneerForm() {
        const { changeLocked } = this.props;
        const { payoneerValue } = this.state;
        return (
            <form onSubmit={this.onPayoneerSubmit}>
                <div className="row vertical">
                    <div className="col-3 no-padding">
                        <input
                            type="text"
                            name="payoneerValue"
                            className="input-text"
                            placeholder="Enter your Payoneer id Nerdy****"
                            value={payoneerValue}
                            onChange={this.onInputChange}
                            disabled={changeLocked}
                        />
                    </div>
                    <div className="col-1">
                        {this.renderPayoneerStatus()}
                    </div>
                </div>
                <div />
            </form>
        );
    }

    renderCurrentMethodText() {
        const { payMethodList, payMethod } = this.props;
        const methodItem = payMethodList[payMethod];
        return (
            <b>{getMethodName(payMethod)} ({methodItem.value})</b>
        );
    }

    render() {
        const { payoneerLink, changeLocked, payMethod, isLoadingPayMethod, payMethodList } = this.props;
        const className = classNames('payment-info-box', { 'disabled': changeLocked });

        const classNamePAYPAL = classNames('payment-info', { 'active': payMethod === methods.PAYPAL });
        const classNameSKRILL = classNames('payment-info', { 'active': payMethod === methods.SKRILL });
        const classNamePayoneer = classNames('payment-info', { 'active': payMethod === methods.Payoneer });

        let availabilityPayMethod = Object.values(methods);
        availabilityPayMethod = Object.values(methods).filter(item => !(changeLocked || isLoadingPayMethod || !payMethodList[methods[item]].verified || payMethodList[methods[item]].locked));

        return (
            <div>
                {!changeLocked && payMethod &&
                    <div className="bg-context">
                        Current withdrawal payment method: {this.renderCurrentMethodText()}
                    </div>
                }

                {changeLocked &&
                    <div className="bg-context alert-danger">
                        Primary payment method modification will be available after <b>{formatTime(changeLocked, 'd')}</b>
                    </div>
                }

                {!payMethod && !isLoadingPayMethod &&
                    <div className="bg-context alert-danger">
                        You are welcome to start working on orders before setting up the payment method! The money will be stored on your profile waiting for any payment method.
                </div>
                }


                <div className={className}>
                    <div className="payment-info payment-info--dropdown">
                        <div className="row vertical">
                            <div className="col-1">
                                <b>Primary payment option:</b>
                            </div>
                            <div className="col-2">
                                <div className="row vertical">
                                    <div className="col-3">
                                        {(availabilityPayMethod.length > 0 || isLoadingPayMethod) &&
                                            <PaymentsTypeDropdown
                                                payments={availabilityPayMethod}
                                                onChange={(e) => this.onSavePayMethod(e)}
                                                payMethod={payMethod}
                                                disabled={isLoadingPayMethod}
                                            />
                                        }
                                        {!availabilityPayMethod.length && !isLoadingPayMethod &&
                                            <div className="text-danger">Please set up at least one payment option below</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={classNamePAYPAL}>
                        <div className="row vertical">
                            <div className="col-1">
                                <img className="img-payment" src={pp} alt="" width="74px" />
                            </div>
                            <div className="col-2">
                                {this.renderPayPalForm()}
                            </div>
                        </div>
                    </div>
                    <div className={classNameSKRILL}>
                        <div className="row vertical">
                            <div className="col-1">
                                <img className="img-payment" src={skrill} alt="" width="47px" />
                            </div>
                            <div className="col-2">
                                {this.renderSkrillForm()}
                            </div>
                        </div>
                    </div>
                    <div className={classNamePayoneer}>
                        <div className="row vertical">
                            <div className="col-1">
                                <img className="img-payment" src={payoneer} alt="" width="68px" />
                            </div>
                            <div className="col-2">
                                {this.renderPayoneerForm()}
                            </div>
                        </div>
                    </div>
                    <div className="additional-info">
                        <div className="link-item"><a href="http://tracking.payoneer.com/aff_c?offer_id=350&aff_id=8861" target="_blank" rel="noopener noreferrer">Registration link</a></div>
                        {!!payoneerLink &&
                            <div className="link-item"><a href={payoneerLink} target="_blank" rel="noopener noreferrer">Payment link</a></div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const getSkrillLink = (email, name, id, address, country) => {
    email = encodeURIComponent(email);
    name = encodeURIComponent(name);
    id = encodeURIComponent(id);
    address = encodeURIComponent(address);
    country = encodeURIComponent(country);
    const date = encodeURIComponent(moment().format('D/M/YYYY'));
    return `https://rightsignature.com/forms/SkrillConsultancy-75d587/embedded/0727c1f5a34?signer[email]=${email}&signer[name]=${name}&ff[fullname_1]=${name}&ff[fullname_2]=${name}&ff[wid]=${id}&ff[address]=${address}&ff[country]=${country}&ff[date]=${date}`;
};

const getPayoneerLink = token => `https://payouts.payoneer.com/partners/lp.aspx?token=${encodeURIComponent(token)}`;

const mapStateToProps = state => {
    const { user } = state;
    const { fetchingFields, pay_methods_list, pay_method } = user;
    return {
        payMethodList: pay_methods_list,
        payMethod: pay_method,
        isLoadingPayMethod: fetchingFields.indexOf('pay_method') > -1,
        isSkrillReqsMet: !!user.name && !!user.country && user.passport_verified && user.profile_residence_verified,
        skrillLink: !user.profile_skrill_tc_accept ? getSkrillLink(user.email, user.name, user.wr_id, user.residence_address, user.country) : null,
        payoneerLink: !user.profile_payoneer_reg_token ? null : getPayoneerLink(user.profile_payoneer_reg_token),
        changeLocked: user.payment_change_locked
    }
};

const mapDispatchToProps = dispatch => ({
    savePayMethod: event => dispatch(userSetFieldFetch('pay_method', event.target.value)),
    savePayMethodDropdown: value => dispatch(userSetFieldFetch('pay_method', value)),
    savePayMethodValue: (name, value) => dispatch(userSetFieldFetch('set_pay_method', { name, value }))
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInfoForm);



// WEBPACK FOOTER //
// ./src/components/profile/PaymentInfoForm.js